import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 205  -  按钮分歧结束
 */

export default class EventButtonDifEnd extends EventBase {
  /**
   * 按钮分歧结束的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }

  /**
   * 事件ID
   */
  Code = EventID.ButtonDifEnd

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
